// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"237":"pages","409":"my","970":"payments"}[chunkId] || chunkId) + "." + {"237":"01c87445","409":"3f467300","523":"7c601777","970":"2cadd20e"}[chunkId] + ".js";
};